import { ThunkType } from "../../../../../core/store/reducers";
import { getCommReviewReport } from "../api/getCommReviewReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../commReviewDataSlice";

export const downloadCommReviewReport = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.exchbusiness.commReview;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const ordersReport = await dispatch(getCommReviewReport(user, filter));
  if (ordersReport) {
    fileDownload(
      new Blob([ordersReport as any], { type: "application/pdf" }),
      "CommissionReview.pdf"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
